export const POPUP_NOTIIFCATION_REQUEST="POPUP_NOTIIFCATION_REQUEST"
export const POPUP_NOTIFICATION_RESPONSE="POPUP_NOTIFICATION_RESPONSE"
export const SET_NOTIFICATION_VISITED_REQUEST="SET_NOTIFICATION_VISITED_REQUEST"
export const NOTIFICATION_LIST_REQUEST="NOTIFICATION_LIST_REQUEST"
export const NOTIFICATION_LIST_RESPONE="NOTIFICATION_LIST_RESPONE"
export const SET_NOTIFICATION_SEEN="SET_NOTIFICATION_SEEN"